<template>
  <div class="Schedules lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Schedules-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Schedules-main lxn-pos-rel">
      <div class="Schedules-main-wrapper lxn-margin-auto lxn-border-round">
        <TitleBox v-for="(hubSchedules, index) in hubsSchedules" :key="index" :titleBgColor="titleBgColor(index)" bgColor="#ECECEC">
          <template v-slot:title>
            {{hubName(hubSchedules.hubUUID)}}
          </template>
          <template v-slot:body>
            <div v-if="hubSchedules.schedules.length == 0 && hubSchedules.error" class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Schedules_loadError}}
            </div>
            <div v-else-if="hubSchedules.schedules.length == 0"  class="lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Schedules_noSchedule}}
            </div>
            <div class="Schedules-wrapper-schedule lxn-margin-auto lxn-border-round lxn-overflow-hidden lxn-pos-rel" v-for="(schedule, index2) in hubSchedules.schedules" :key="index+'-'+index2">
              <div class="Schedules-schedule-color lxn-h100" :class="[$store.getters.language.floatClass]" :style="scheduleColor(schedule.color)">
              </div>
              <div class="Schedules-wrapper-Scenario-text lxn-h100" :class="$store.getters.language.floatClass">
                <div class="Schedules-Scenario-text lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                  {{schedule.name}}
                </div>
              </div>
              <div class="Scenarios-Scenario-setting lxn-h100" :class="$store.getters.language.floatClass">
                <ButtonIcon @click="editSchedule(schedule)" :size="50" bgColor="#1EA5DE" icon="cog" iconColor="#FFFFFF" :padding="8" />
              </div>
            </div>
          </template>
        </TitleBox>
      </div>
      <div class="Schedules-button lxn-margin-auto lxn-w100">
        <CustomButton @click="addSchedule" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
          {{$store.getters.language.texts.Schedules_button}}
        </CustomButton>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomButton from '@/components/CustomButton.vue'
import CustomCurve from '@/components/CustomCurve.vue'
import SingleSwitch from '@/components/SingleSwitch.vue'
import TitleBox from '@/components/TitleBox.vue'
import TopNav from '@/components/TopNav.vue'
import * as CONFIGS from '@/statics/configs.js'
import luxinLanguages from '@/statics/language.js'
import Logger from '@/statics/logger.js'
import Messaging from '@/statics/messaging.js'
import {INSTRUCTION_CONDITION_TYPE} from "@/statics/configs.js";
import * as moment from 'jalali-moment';
import ButtonIcon from "@/components/ButtonIcon";

export default {
  name: 'Schedules',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    SingleSwitch,
    ButtonIcon
  },
  data: function () {
    return {
      hubsSchedules: [],
    }
  },
  mounted: async function () {
    if(this.$store.state.hubs.length === 0){
      alert(this.$store.getters.language.texts.Schedules_alert);
      this.$router.push('/home/dashboard/');
    }else{
      this.$store.commit('setAppBusy', true);
      setTimeout(x => {
        for(var i = 0; i < this.$store.state.hubs.length; i++){
          var hub = this.$store.state.hubs[i];
          this.hubsSchedules.push({
            hubUUID: hub.uuid,
            error: false,
            schedules: [],
          });
            this.getHubInstructions(hub);
        }
      }, 2000);
    }
  },
  watch: {
  },
  computed: {
    trashIconStyle: function () {
      if(luxinLanguages[this.$store.state.language].isRTL){
        return "left: 10px;";
      }else{
        return "right: 10px;";
      }
    },
  },
  methods: {
    getHubInstructions: function (hub) {
      const psk = hub.psk;
      const destinationUUID = hub.uuid;
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: psk,
        destinationUUID: destinationUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      this.$store.dispatch('readHubInstructions', {
        messagingHook: messagingHook,
        hubUUID: destinationUUID,
      })
          .then(response => {
            const schedules = response.body.bodyContent.instructionList.filter(x => x.instructionId >= 10000 && x.instructionId <= 19999);
            let schedulesState = this.$store.state.schedules;
            schedules.filter(x => !schedulesState.map(s => s.instructionId).includes(x.instructionId)).forEach(x => {
              this.$store.commit('addSchedule', {
                name: this.$store.getters.language.texts.Scenarios_scheduleCommonName,
                color: 0,
                hubUUID: hub.uuid,
                instructionId: x.instructionId,
              });
            });
            schedulesState.filter(x => !schedules.map(s => s.instructionId).includes(x.instructionId)).forEach(x => {
              this.$store.commit('deleteSchedule', x.instructionId);
            });
            this.$store.commit('saveState');
            schedulesState = this.$store.state.schedules;
            this.hubsSchedules.find(x => x.hubUUID === hub.uuid).schedules = schedules.map(x => {
              return schedulesState.find(s => s.instructionId === x.instructionId);
            });
            this.$store.commit('setAppBusy', false);
          })
          .catch( response => {
            if(response.rejectCode === 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
            this.$store.commit('setAppBusy', false);
          });
    },
    setSchedules: async function (hub) {
      const messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: hub.uuid,
        sourceUUID: this.$store.state.user.uuid
      });
      try {
        let instructionList = await this.$store.dispatch('readHubInstructions', {messagingHook: messagingHook,hubUUID: hub.uuid,});
        instructionList = instructionList.body.bodyContent.instructionList;
        const schedules = this.$store.getters.getSchedules(hub.uuid);
        instructionList.forEach(x => {
          const sch = schedules.find(s => s.instructionId === x.instructionId);
          x.name = sch != null ? sch.name : '';
          x.color = sch != null ? sch?.color : 0;
          if (x.condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.SINGLESHOT){
            x.condition.condition.date = this.getDateTimeFromStamp(x.condition.condition.dateStamp, x.condition.condition.timeStamp);
            x.condition.typeName = this.$store.getters.language.texts.AddSchedule_text13;
          } else if (x.condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.WEEKLY){
            x.condition.condition.date = this.getHourMinuteFromTimeStamp(x.condition.condition.timeStamp);
            x.condition.condition.repeatDays = this.numberToBooleanList(x.condition.condition.weekday);
            x.condition.typeName = this.$store.getters.language.texts.AddSchedule_text12;
          } else if (x.condition.type === CONFIGS.INSTRUCTION_CONDITION_TYPE.PERIODIC){
            x.condition.condition.on = x.condition.condition.onDuration / 1000;
            x.condition.condition.off = x.condition.condition.offDuration / 1000;
            x.condition.typeName = this.$store.getters.language.texts.AddSchedule_text14;
          }
        })
        this.hubsSchedules.find(x => x.hubUUID === hub.uuid).schedules = instructionList;
        this.$store.commit('setAppBusy', false);
      }
      catch (response) {
        if(response.rejectCode === 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        // this.hubsSchedules[response.hubIndex].error = true;
        this.$store.commit('setAppBusy', false);
      }
    },
    secondaryScheduleTimeEvent: function(schedule) {
      let primaryScheduleId = schedule.eventIdToWatch & 0xFF
      let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
      let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(schedule.hubUUID, secondaryScheduleEventId);
      return secondarySchedule.timeEvent
    },
    goBack: function () {
      this.$router.push('/home/dashboard/');
    },
    getDateTimeFromStamp(dateStamp, timeStamp) {
      const epochTime = dateStamp * 86400000 + timeStamp;
      const m = moment(epochTime).locale('fa');
      return m.format('YYYY/MM/DD HH:mm');
    },
    getHourMinuteFromTimeStamp(timeStamp) {
      const totalMinutes = Math.floor(timeStamp / 60000);
      const hour = Math.floor(totalMinutes / 60);
      const minute = totalMinutes % 60;
      const HH = String(hour).padStart(2, '0');
      const mm = String(minute).padStart(2, '0');
      return `${HH}:${mm}`;
    },
    numberToBooleanList(num) {
      const binaryStr = num.toString(2); // تبدیل به باینری
      return [...binaryStr].map(bit => bit === '1');
    },
    titleBgColor: function (index) {
      return this.$store.state.themeMainColors[this.$store.state.hubs[index].color];
    },
    addSchedule: function () {
      this.$router.push('/addSchedules/');
    },
    updaete_schedule_dateTimeStamp: async function (schedule, fetchedSchedulesList, messagingHook, hubUUID) {
      var scheduleDateTimeStamp = schedule.timeEvent.dateStamp * 86400000 + schedule.timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();

      var currentEpochTime = Date.now();

      var targetDateStamp = 0;
      var targetTimeStamp = 0;

      var localDateObject = new Date();
      var repeatMask = 0;

      var userSelectedLocalTimeStamp = (hours*60 + minutes) * 60000;
      var currentLocalTimeStamp = ((localDateObject.getHours()*60 + localDateObject.getMinutes()) * 60 + localDateObject.getSeconds()) * 1000;
      var timeStampDiff = userSelectedLocalTimeStamp - currentLocalTimeStamp;
      
      if(timeStampDiff < 0){
        timeStampDiff += 86400000;
      }
      var userSelectedDateTimeStamp = currentEpochTime + timeStampDiff;
      targetDateStamp = Math.floor(userSelectedDateTimeStamp / 86400000);
      targetTimeStamp = userSelectedDateTimeStamp % 86400000;
      repeatMask = CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL;

      fetchedSchedulesList.find((scheduleOnHub, scheduleIndex) => {
        if(scheduleOnHub.eventId == schedule.eventIdToWatch){
          fetchedSchedulesList[scheduleIndex].timeEvent = {
            dateStamp: targetDateStamp,
            timeStamp: targetTimeStamp,
            repeatMask: repeatMask,
          }
          return true;
        }
        return false;
      })
      await this.$store.dispatch('setHubSchedules', {
        messagingHook: messagingHook,
        hubUUID: hubUUID,
        bodyContent: {
          schedulesList: fetchedSchedulesList,
        }
      });
      this.$store.commit('updateScheduleTimeEvent', {
        scheduleIndex: schedule.index,
        timeEvent: {
          dateStamp: targetDateStamp,
          timeStamp: targetTimeStamp,
          repeatMask: repeatMask,
        }
      })
    },
    isTriggerTimeHasPassed: function(schedule) {
      var scheduleDateTimeStamp = schedule.timeEvent.dateStamp * 86400000 + schedule.timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();

      var localDateObject = new Date();

      var userSelectedLocalTimeStamp = (hours*60 + minutes) * 60000;
      var currentLocalTimeStamp = ((localDateObject.getHours()*60 + localDateObject.getMinutes()) * 60 + localDateObject.getSeconds()) * 1000;
      var timeStampDiff = userSelectedLocalTimeStamp - currentLocalTimeStamp;
      
      if(timeStampDiff < 0){
        return true;
      }
      return false;
    },
    toggleSchedule: async function (schedule) {
      this.$store.commit('setAppBusy', true);
      var hub = this.$store.getters.getHubByUUID(schedule.hubUUID);
      var messagingHook = new Messaging(new Logger(false));
      messagingHook.init({
        psk: hub.psk,
        destinationUUID: schedule.hubUUID,
        sourceUUID: this.$store.state.user.uuid
      });
      try {
        var fetchedSchedulesList = await this.$store.dispatch('readHubSchedules', {messagingHook: messagingHook,hubUUID: hub.uuid});
        fetchedSchedulesList = fetchedSchedulesList.body.bodyContent.schedulesList;
        var hubSchedule = fetchedSchedulesList.find(hubSchedule => hubSchedule.eventId == schedule.eventIdToWatch);

        if(hubSchedule){
          // reverse the schedule mask 
          let  primaryTriggertimeHasPassed = false;
          let  secondaryTriggerHasPassed = false;
          if(hubSchedule.timeEvent.repeatMask == CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL){
            primaryTriggertimeHasPassed = this.isTriggerTimeHasPassed(schedule);
            this.updaete_schedule_dateTimeStamp(schedule, fetchedSchedulesList, messagingHook, hub.uuid);
            if (schedule.hasSecondary) {
              let primaryScheduleId = schedule.eventIdToWatch & 0xFF
              let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
              let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hub.uuid, secondaryScheduleEventId);
              secondaryTriggerHasPassed =  this.isTriggerTimeHasPassed(secondarySchedule);
              this.updaete_schedule_dateTimeStamp(secondarySchedule, fetchedSchedulesList, messagingHook, hub.uuid);
            }
          }

          var maskList = [{
            eventId: schedule.eventIdToWatch,
            isMasked: schedule.active,
          }];
          if (schedule.type == 2 && schedule.hasSecondary){
            // reverse the secondary schedule mask and masks of the schedule command
            let primaryScheduleId = schedule.eventIdToWatch & 0xFF
            let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
            let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hub.uuid, secondaryScheduleEventId);
            maskList.push({
              eventId: secondarySchedule.eventIdToWatch,
              isMasked: maskList[0].isMasked,
            });
            for (let k=0; k < schedule.commandMaskList.length; k++) {
              let mask = schedule.commandMaskList[k];
              if (this.$store.state.schedules[secondarySchedule.index].active) {
                // if the schedule currently is active and we want to disable it, then we disable the notification eventId also, so completely 
                // disable the notification, but if the schedule is not active right now and we want to enable it ,we have to check if we are in
                // the scheduled time to disable the mask
                maskList.push({
                  eventId: mask.eventId,
                  isMasked: true
                }) 
              } else {
              
                if (mask.isMasked == true) { // if the primary mask is true so the secondary mask is responsible for activating the notification
                  if (secondaryTriggerHasPassed) {
                    maskList.push({
                      eventId: mask.eventId,
                      isMasked: false
                    })      
                  }
                } else {
                  if (primaryTriggertimeHasPassed && !secondaryTriggerHasPassed) {
                    maskList.push({
                      eventId: mask.eventId,
                      isMasked: false
                    })      
                  }
                }
              }
            }
          }
          await this.$store.dispatch('setEventMasks', {
            messagingHook: messagingHook,
            hubUUID: hub.uuid,
            bodyContent: {
              maskList: maskList
            }
          });
          let newState = !schedule.active;
          this.$store.commit('updateScheduleActive', {
            scheduleIndex: schedule.index,
            active: newState,
          });
          if (schedule.type == 2 &&  schedule.hasSecondary){
            let primaryScheduleId = schedule.eventIdToWatch & 0xFF
            let secondaryScheduleEventId = (CONFIGS.SCHEDULE_EVENT_ID_PREFIX << 8) + primaryScheduleId + 1
            let secondarySchedule = this.$store.getters.getScheduleForHubByEventId(hub.uuid, secondaryScheduleEventId);
            this.$store.commit('updateScheduleActive', {
              scheduleIndex: secondarySchedule.index,
              active: newState,
            });
          }
        }
        this.$store.commit('saveState');
        this.$store.commit('setAppBusy', false);
      }
      catch (response) {
        if(response.rejectCode == 2){
          this.$store.commit('setHubStatus', {
            hubIndex: response.hubIndex,
            connectionStatus: {
              local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
              online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            },
          });
        }
        this.$store.commit('setAppBusy', false);
      }
    },
    hubName: function (hubUUID) {
      var hub = this.$store.getters.getHubByUUID(hubUUID);
      return hub.name
    },
    scheduleColor: function (colorIndex) {
      return "background-color: " + this.$store.state.themeMainColors[colorIndex] + ";";
    },
    repeatDaysSelected: function (repeatDays, index) {
        return repeatDays[index] ? 'active' : '';
    },
    getTypes: function () {
      return CONFIGS.INSTRUCTION_CONDITION_TYPE;
    },
    scheduleButtonColor: function (colorIndex) {
      return this.$store.state.themeMainColors[colorIndex];
    },
    openCommand: function (hubUUID, eventId) {
      this.$router.push('/showInstruction/' + hubUUID + "/" + eventId);
    },
    getSceduleTime: function (timeEvent) {
      var scheduleDateTimeStamp = timeEvent.dateStamp * 86400000 + timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();
      hours = ("00" + hours).slice(-2);
      minutes = ("00" + minutes).slice(-2);
      return hours + ":" + minutes;
    },
    getScheduleDays: function (timeEvent) {
      var scheduleDateTimeStamp = timeEvent.dateStamp * 86400000 + timeEvent.timeStamp;
      var dateObject = new Date(scheduleDateTimeStamp);
      var hours = dateObject.getHours();
      var minutes = dateObject.getMinutes();

      var weekDaysOffset = 0;
      var timeZoneOffset = new Date().getTimezoneOffset();

      var timeStampInMinutes = hours*60 + minutes + timeZoneOffset;

      if(timeStampInMinutes < 0){
        weekDaysOffset = 1;
      }else if(timeStampInMinutes >= 24*60){
        weekDaysOffset = -1;
      }

      var selectedDays = '';
      if((timeEvent.repeatMask & CONFIGS.SCHEDULE_REPEAT_MASK_OCCATIONAL) != 0){
        return '';
      }
      var daysInOrder = [6, 0, 1, 2, 3, 4, 5];
      if(weekDaysOffset == 1){
        daysInOrder = [5, 6, 0, 1, 2, 3, 4];
      }else if(weekDaysOffset == -1){
        daysInOrder = [0, 1, 2, 3, 4, 5, 6];
      }
      var everyDay = true;
      for(var i = 0; i < 7; i++){
        if((timeEvent.repeatMask & CONFIGS.SCHEDULE_REPEAT_MASK_WEEKDAYS[daysInOrder[i]]) != 0){
          var weekDayWithOffset = (((i + weekDaysOffset) % 7) + 7) % 7;
          selectedDays += ' ' + this.$store.getters.language.texts.weekDays[daysInOrder[weekDayWithOffset]]
        }else{
          everyDay = false;
        }
      }
      if(everyDay){
        return this.$store.getters.language.texts.Schedules_everyDay
      }else{
        return selectedDays.substring(1);
      }
    },
    editSchedule: function (schedule) {
      this.$router.push('/editSchedule/' + schedule.instructionId);
    }
  }
}
</script>

<style>
  .Schedules-topCurve-wrapper {
    height: 200px;
  }
  .Schedules-main {
    z-index: 2;
  }
  .Schedules-main-wrapper {
    min-height: 150px;
    width: calc(100% - 36px);
    margin-top: -150px;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .Schedules-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .Schedules-wrapper-schedule {
    width: calc(100% - 14px);
    height: 50px;
    background-color: #FFFFFF;
    margin-top: 14px;
  }
  .Schedules-wrapper-schedule:first-child {
    margin-top: 0px;
  }
  .Schedules-wrapper-Scenario-text {
    width: calc(100% - 60px);
  }
  .Schedules-schedule-color {
    width: 10px;
  }
  .Schedules-Scenario-text {
    line-height: 50px;
    padding-left: 5px;
    padding-right: 5px;
    color: #52626C;
  }
  .Schedules-schedule-wrapper-fields {
    width: calc(100% - 10px);
    padding: 10px;
    padding-bottom: 0;
  }
  .Schedules-schedule-wrapper-switch {
    width: 80px;
    margin-top: 10px;
  }
  .Schedules-schedule-wrapper-time {
    height: 25px;
    font-size: 20px;
  }
  .Schedules-schedule-wrapper-name {
    font-size: 14px;
    line-height: 40px;
  }
  .Schedules-schedule-wrapper-type {
    font-size: 10px;
    line-height: 20px;
  }
  .Schedules-schedule-wrapper-date {
    font-size: 12px;
    line-height: 20px;
  }
  .Schedules-schedule-wrapper-days {
    height: 12px;
    font-size: 8px;
    line-height: 12px;
  }
</style>
